const dtHandler = require('../../../../../components/dt/dt-handler')
const dtSearch = require('../../../../../components/dt/dt-search')
const emailTrackingMenu = require('./emailTracking-menu')
const { organizeRow } = require('./emailTracking-dt-handler')
const { tableDetail } = require('./emailTracking-dt-handler')

/****************ELEMENTS*****************/
var htmlDt = {}
var HTMLwasSelected = false

function HTMLselect() {

      dtHandler.HTMLselect('emailTracking-dt', htmlDt, organizeRow, tableDetail)
      HTMLwasSelected = true

}/**/

/****************ELEMENTS*****************/

export function start(detail) {

      if (!HTMLwasSelected) { HTMLselect() }

      obj[detail.act].start(detail)

}/**/

const obj = {

      filter:         { start: (detail) => { dtSearch.filter(detail, htmlDt)         } },
      filterShowHide: { start: (detail) => { dtSearch.filterShowHide(detail, htmlDt) } },
      loadMore:       { start: (detail) => { dtSearch.loadMore(detail, htmlDt)       } },
      searching:      { start: (detail) => { dtSearch.searching(detail, htmlDt)      } },
      select:         { start: (detail) => { dtSearch.select(detail, htmlDt, true)   } },
      th:             { start: (detail) => { dtSearch.th(detail, htmlDt)             } },
      trMenu:         { start: (detail) => { emailTrackingMenu.start(detail, htmlDt) } },
      openPdf:        { start: (detail) => { openPdf(detail)                         } },

}/**/

function openPdf(detail) {

      const trackingId = Number.parseInt(detail.dbid, 10)

      if (!Number.isInteger(trackingId) || trackingId < 1) { return }

      const pdfUrl = `./server/php/queries/openEmailTrackingPdf.php?id=${encodeURIComponent(trackingId)}`
      const newTab = window.open(pdfUrl, '_blank')

      if (newTab) { newTab.opener = null }
}
